export default /*START_META*/{
  "title": "Features available in tradly apps"
}; /*END_META*/